import { H2, Image, P, Section, SpacerWrapper, Wrapper } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import classNames from 'classnames';
import React, { Fragment } from 'react';

import ambulanceData from './data';
import styles from './styles.module.sass';
import uncapFpIterator from '../../../../../../../utils/uncap-fp-iterator';

type AmbulanceSectionProps = {
  isStacked?: boolean;
};

const AmbulanceSection = ({ isStacked = false }: AmbulanceSectionProps) => {
  const { image, summary, title } = ambulanceData;

  return (
    <Section variant={['paddingTopSpacer9', 'paddingBottomSpacerNone']}>
      {/* @ts-expect-error - Automatic, Please fix when editing this file */}
      <Wrapper className={classNames(styles.wrapper, { [styles.isStacked]: isStacked })}>
        <SpacerWrapper variant="paddingBottomSpacer11">
          <H2 looksLike="h4" variant="simpleBit">
            {title}
          </H2>
          <P variant="small14">
            {uncapFpIterator(map)(
              // @ts-expect-error - Automatic, Please fix when editing this file
              (line, index) => (
                <Fragment key={index}>
                  {line}
                  <br />
                </Fragment>
              ),
              summary,
            )}
          </P>
        </SpacerWrapper>
        <Image
          // @ts-expect-error - Automatic, Please fix when editing this file
          className={classNames(styles.image, { [styles.isStacked]: isStacked })}
          src={image.src}
          alt={image.alt}
        />
      </Wrapper>
    </Section>
  );
};

export default AmbulanceSection;
